import React from "react";
import * as CHQ from "chq";

import { useProfile } from "app/context";
import InstagramLink from "app/links/InstagramLink";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type InstagramPostCreatedNotificationProps = {
  notification: CHQ.NotificationInstagramPostCreated;
  tabIndex?: number;
};

const InstagramPostCreatedNotification: React.FC<InstagramPostCreatedNotificationProps> = ({
  notification: { entity }
}) => {
  const { profile } = useProfile();

  return (
    <NotificationBody actor={entity?.creator || profile}>
      Your
      {" "}
      <Trans>
        {entity.url ? (
          <InstagramLink link={entity.url}>
            <Trans>Instagram post</Trans>
          </InstagramLink>
        ) : (
          <Trans>Instagram post</Trans>
        )}
        {" "}
        was created successfully
      </Trans>
      <br />
      <br />
      <span>{entity?.message}</span>
    </NotificationBody>
  );
};

export default InstagramPostCreatedNotification;
